import React, { useState, useEffect } from "react";
import { openDB } from "idb";
import formStyles from "../css/SetupForm.module.css";
import { CancelRounded } from '@mui/icons-material';

const style = {
  popupContiner: {
    position: 'absolute',
    background: '#00000052',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    zIndex: '1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  container: {
    padding: '25px',
    background: 'white',
    boxShadow: '0 0 5px 0px black',
    borderRadius: '15px',
    fontSize: '25px',
    margin: '10px 10px 20px',
    alignItems: 'center',
    maxHeight: '50%',
    position: 'relative'
  },
  heading: {
    margin: '10px 5px 20px'
  },
  inputsContainer: {
    padding: "0 10px",
    overflow: 'auto',
    width: '100%'
  },
  label: {
    padding: '8px',
    fontSize: '18px',
    borderRadius: '5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  button: {
    marginTop: '20px',
    width: 'fit-content'
  },
  close: {
    position: 'absolute',
    right: '10px',
    top: '10px',
  }
}

const BrandSelectionPopUp = ({ onSelect, close, options }) => {

  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(0);

  useEffect(() => {
    const readDB = async () => {
      const db = await openDB("FoodDo", +localStorage.getItem('IDBVersion') || 1);
      let brands = await (db.transaction("brand", "readonly").objectStore("brand")).getAll();
      if (options?.[0]) brands = brands?.filter(i => options.includes(i.brand_uuid))
      setSelectedBrand(brands?.[0]?.brand_uuid)
      setBrands(brands);
    };
    readDB();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={style.popupContiner}>
      <div className={formStyles.form} style={style.container}>
        <h3 style={style.heading}>Brand Selection</h3>
        <div style={style.inputsContainer}>
          {brands?.map(({ brand_uuid, brand_name }, index) => {
            return <label htmlFor={brand_uuid} style={style.label}>
              <input id={brand_uuid} type="radio" name='brand-selection' defaultChecked={selectedBrand === brand_uuid} onChange={e => e.target.checked && setSelectedBrand(brand_uuid)} />
              {brand_name.trim() || String(brand_uuid).trim() || `Brand #${index + 1}`}
            </label>
          })}
        </div>
        <button
          type="button"
          className={formStyles.submit}
          onClick={e => onSelect(selectedBrand)}
          style={style.button}
        >
          Select
        </button>
        <CancelRounded onClick={close} style={style.close} />
      </div>
    </div>
  );
}

export default BrandSelectionPopUp;